
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/lanethompson/TheRightLane/blog/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/lanethompson/TheRightLane/blog/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/lanethompson/TheRightLane/blog/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/lanethompson/TheRightLane/blog/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/Users/lanethompson/TheRightLane/blog/node_modules/babel-preset-env/lib/index.js\",\"/Users/lanethompson/TheRightLane/blog/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/lanethompson/TheRightLane/blog/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./tags.js") })
        }
      }, "page-component---src-templates-tags-js");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=page-component---src-templates-tags-js!./src/templates/tags.js
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=page-component---src-templates-tags-js!./src/templates/tags.js
// module chunks = 45